
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import AcademySidemenuLayout from '@/components/organisms/layout/AcademySidemenuLayout.vue'
import RegistDataPanel from '@/components/organisms/manage/RegistDataPanel.vue'
import UserListPanel from '@/components/organisms/manage/UserListPanel.vue'
import MenuEditUser from '@/components/organisms/floatmenu/MenuEditUser.vue'
import { UserList } from '@/models/manage/UserList'
import { SelectItem } from '@/models/SelectItem'

/**
 * 先生一覧のレイアウト
 */
@Component({
  components: {
    ButtonBase,
    AcademySidemenuLayout,
    RegistDataPanel,
    UserListPanel,
    MenuEditUser,
  },
})
export default class AcademyTeacherList extends Vue {
  /** サイドメニュー部 */
  @Ref()
  private academySidemenuLayout!: AcademySidemenuLayout

  /** ユーザ一覧パネル */
  @Ref()
  private userListPanel!: UserListPanel

  /** 編集メニュー */
  @Ref()
  private menuEditUser!: MenuEditUser

  /** 先生一覧 */
  @Prop()
  private userList!: UserList[]

  /** 教室フィルターの選択肢 */
  @Prop()
  private filterBranchList!: SelectItem[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** フィルター変更時のイベント */
  @Prop()
  private changeFilter!: () => void

  /** 検索ボタン押下時の処理 */
  @Prop()
  private eventClickSearch!: () => void

  /** ユーザ登録ボタン押下時のイベント */
  @Prop()
  private eventClickCreateUserButton!: () => void

  /** 削除ボタン押下時のイベント */
  @Prop()
  private eventClickDeleteButton!: (userId: number) => void

  /** ユーザデータ編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditUserDataButton!: (userId: number) => void

  /** パスワード編集ボタン押下時のイベント */
  @Prop()
  private eventClickEditPasswordButton!: (userId: number) => void

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /**
   * 編集ボタンクリック時の処理
   *
   * @param event イベント
   * @param userId 対象ユーザID
   */
  private async eventClickEditButton(event: Event, userId: number): Promise<void> {
    await this.menuEditUser.show(
      event.target as HTMLElement,
      userId,
      this.academySidemenuLayout.sidemenuLayout.contentMain
    )
  }

  /**
   * 選択中の教室
   *
   * @returns 教室コード
   */
  public currentBranch(): string | null {
    return this.userListPanel.currentBranch()
  }

  /**
   * 教室フィルターの選択値を設定
   *   選択肢の変更時にselectの値を直接書き換える
   *
   * @param value 選択値指定
   */
  public setCurrentBranch(value: string): void {
    this.userListPanel.setCurrentBranch(value)
  }

  /**
   * 検索欄に入力された文字列
   *
   * @returns 入力された文字列
   */
  public textInputedSearch(): string {
    return this.userListPanel.textInputed()
  }
}
